import React from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";

function OrderStatusFilter(props) {
  const { classes } = props;

  let value = "ALL";
  if (props["status"]?.value === 0) {
    value = "0";
  } else if (props["status"]?.value === 1) {
    value = "1";
  }

  const status = [
    {
      value: "ALL",
      label: getTranslation("bestellingen.filers.ostatus.all", "Standaard weergave"),
    },
    {
      value: "0",
      label: getTranslation("bestellingen.filers.ostatus.normal", "Alles ook niet betaald"),
    },
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let selectedStatusOrder = e.target.value;

        switch (selectedStatusOrder) {
          case "ALL":
            props.setFilter("status", null);
            break;
          case "0":
            props.setFilter("status", { field: "status", operator: ">=", value: 0 });
            break;
        }
      }}
      value={value}
    >
      {status.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["status"]: state.filtersV2["status"],
  /*   ["vestiging_id"]: state.filtersV2["vestiging_id"], */
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OrderStatusFilter, productenStyle));
